/**
 * 示例第三方 slot 图标
 */
import * as React from 'react';
/** 示例功能图标（星形） */
export function SampleSlotIcon(_props) {
    return React.createElement('svg', {
        width: '20',
        height: '20',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
    }, React.createElement('polygon', {
        points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2',
    }));
}
//# sourceMappingURL=sample-slot-icon.js.map